<h2 mat-dialog-title>Salut {{data.userEmail}}</h2>
<mat-dialog-content>
    @if (data.userEmail === 'unknown') {
        <p class="warning">Impossible de récupérer ton email. Reconnecte toi via Google OAuth.</p>
    }@else if (data.groupId === '') {
        <p class="warning">Impossible de récupérer l'ID du groupe. Réessaye plus tard.</p>
    }@else {
        <p>Veux-tu bien donner la raison pour laquelle tu as besoin du mot de passe CouchDB ?</p>
    }
  <mat-form-field class="reason-full-width">
    <mat-label>Raison*</mat-label>
    <input matInput maxlength="500" [(ngModel)]="reason" />
    <mat-hint align="start"><strong>Champ obligatoire</strong> </mat-hint>
    <mat-hint align="end">{{reason()?.length || 0}} / 500</mat-hint>
  </mat-form-field>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button (click)="onNoClick()">Non merci</button>
  <button mat-button [disabled]="data.groupId === '' || data.userEmail === 'unknown' || !reason()" [mat-dialog-close]="reason()" cdkFocusInitial>Voir le mot de passe</button>
</mat-dialog-actions>